// Phase 9 R3 — Reserve stock against a parts line via R1 RPC.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from 'sonner';

export function useReserveInventoryForPartsLine() {
  const { activeShop } = useAuth();
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({
      partsLineId,
      qty,
    }: {
      partsLineId: string;
      qty: number;
      // Carried for invalidation; not part of RPC signature.
      ticketId?: string;
      inventoryItemId?: string;
    }) => {
      const { data, error } = await supabase.rpc('reserve_inventory_for_parts_line', {
        p_parts_line_id: partsLineId,
        p_qty: qty,
      });
      if (error) throw error;
      return data;
    },
    onSuccess: (_data, vars) => {
      const shopId = activeShop?.id;
      if (vars.ticketId) {
        qc.invalidateQueries({ queryKey: ['parts-lines', shopId, vars.ticketId] });
      }
      if (vars.inventoryItemId) {
        qc.invalidateQueries({ queryKey: ['inventory-item', shopId, vars.inventoryItemId] });
        qc.invalidateQueries({ queryKey: ['inventory-transactions', shopId, vars.inventoryItemId] });
      }
      qc.invalidateQueries({ queryKey: ['inventory-items', shopId] });
      toast.success(`Reserved ${vars.qty}`);
    },
    onError: (e: any) => toast.error(e?.message ?? 'Reservation failed'),
  });
}
